/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Studyprograms_Study_Southeast_Asian_Studies27Inputs */

const en__field__enum_studyprograms_study_southeast_asian_studies27 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Southeast_Asian_Studies27Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Languages and Cultures of Southeast Asia`)
};

const de__field__enum_studyprograms_study_southeast_asian_studies27 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Southeast_Asian_Studies27Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprachen und Kulturen Südostasiens`)
};

/**
* | output |
* | --- |
* | "Languages and Cultures of Southeast Asia" |
*
* @param {_Field__Enum_Studyprograms_Study_Southeast_Asian_Studies27Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_studyprograms_study_southeast_asian_studies27 = /** @type {((inputs?: _Field__Enum_Studyprograms_Study_Southeast_Asian_Studies27Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Studyprograms_Study_Southeast_Asian_Studies27Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_studyprograms_study_southeast_asian_studies27(inputs)
	return de__field__enum_studyprograms_study_southeast_asian_studies27(inputs)
});
export { _field__enum_studyprograms_study_southeast_asian_studies27 as "_field__enum_studyPrograms_STUDY_SOUTHEAST_ASIAN_STUDIES" }